<template>
  <div
    class="mx-auto mb-12 ml-6 flex flex-col gap-y-2 rounded-lg border border-gray-300 pl-6 pt-4"
  >
    <div class="grid grid-cols-9 gap-x-2">
      <div class="col-span-1 font-bold capitalize-first">
        {{ $t('global.supplier_ref') }}
      </div>
      <div class="col-span-5 font-bold capitalize-first">
        {{ $t('global.item') }}
      </div>
      <div class="col-span-1 text-center font-bold capitalize-first">
        {{ $t('global.price_htva') }}
      </div>
      <div class="col-span-1 text-center font-bold capitalize-first">
        {{ $t('global.total_quantity') }}
      </div>
      <div class="col-span-1 font-bold"></div>
    </div>
    <div
      v-for="(supplier_order_item, index) in supplierOrder.supplierOrderItems"
      :key="index"
      class="grid grid-cols-9"
    >
      <div class="col-span-1 font-bold">
        {{ supplier_order_item.item?.default_supplier_ref }}
      </div>
      <div class="col-span-5">
        <div class="mb-5 font-bold">{{ supplier_order_item.name }}</div>
        <div v-for="(dossier, idx) in supplier_order_item.dossiers" :key="idx">
          <div class="mx-10 grid grid-cols-8 font-medium">
            <div
              class="col-span-4 cursor-pointer text-primary"
              @click="
                $router.push({
                  name: 'dossier_form_information_route_edit',
                  params: { id: dossier.id }
                })
              "
            >
              {{ dossier.name }}
            </div>
            <div class="col-span-4 mr-16 w-14 text-center">
              {{ dossier.quantity }}
            </div>
          </div>
          <div
            v-if="
              dossier?.delivery_place_model?.name &&
              dossier?.delivery_place_model?.name !==
                supplierOrder?.delivery_model?.name
            "
            class="mx-14 flex font-medium text-gray-400"
          >
            <font-awesome-icon
              :icon="['fas', 'location-dot']"
              class="mr-1 mt-1 text-theme-danger"
              size="xs"
            />
            <div class="capitalize-first">
              {{
                dossier?.delivery_place_model?.full_name ??
                dossier?.delivery_place_model?.name
              }}
            </div>
          </div>
        </div>
        <div class="mx-10 grid grid-cols-8 justify-start font-medium">
          <div class="col-span-4">
            <span
              v-if="
                supplier_order_item.dossiers &&
                supplier_order_item.dossiers.length > 0
              "
              >{{ $t('global.additional_quantity') }}</span
            >
            <span v-else>{{ $t('attributes.quantity') }}</span>
          </div>
          <div class="col-span-4 mr-16">
            <div class="w-14">
              <BaseShowEditInput
                v-if="supplierOrder.status === 'DRA'"
                v-model="supplier_order_item.quantity_added"
                name="quantity"
                size="extra-small"
                class="text-center"
                @change="refreshTotalQuantity(supplier_order_item)"
              />
              <div v-else class="text-center">
                {{ supplier_order_item.quantity_added }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-1 mt-5">
        <BaseShowEditInput
          v-if="supplierOrder.status === 'DRA'"
          v-model="supplier_order_item.price_htva"
          name="quantity"
          size="extra-small"
          class="w-20 text-center"
          :edition-mode="true"
        />
        <div v-else :class="['mr-10 mt-1 text-right font-bold']">
          {{ supplier_order_item.price_htva ?? '-' }}
        </div>
      </div>
      <div class="col-span-1 mt-6 text-center font-bold">
        {{ supplier_order_item.quantity }}
      </div>
      <div v-if="supplierOrder.status === 'DRA'" class="col-span-1 mt-5">
        <BaseButton
          v-if="
            !supplier_order_item.dossiers ||
            supplier_order_item.dossiers.length === 0
          "
          icon="trash"
          color="danger"
          size="extra-small"
          @click="$emit('delete-item', index)"
        />
      </div>
      <div
        v-else-if="['REC', 'PAR_REC'].includes(supplierOrder.status)"
        class="col-span-1 mt-5 text-center"
      >
        <font-awesome-icon
          v-if="receive_item_ids?.includes(supplier_order_item.id)"
          size="lg"
          :icon="['fas', 'circle-check']"
          class="p-1 text-theme-success"
        />
      </div>
      <div
        v-if="
          supplier_order_item.in_order_stock?.length > 0 &&
          supplierOrder.status === 'DRA'
        "
        class="col-span-3 col-start-2"
      >
        <h1 class="ml-5 font-bold text-primary capitalize-first">à commandé</h1>
        <div
          v-for="(dossier, idx) in supplier_order_item.in_order_stock"
          :key="idx"
        >
          <div class="mx-10 grid grid-cols-8 font-medium">
            <font-awesome-icon
              :icon="
                supplier_order_item.add_order?.includes(dossier.id)
                  ? ['fas', 'square-check']
                  : ['fal', 'square']
              "
              class="ml-5 mt-1 text-primary"
              @click="addInOrderItems(dossier, supplier_order_item)"
            />
            <div
              class="col-span-4 cursor-pointer text-primary"
              @click="
                $router.push({
                  name: 'dossier_form_information_route_edit',
                  params: { id: dossier.id }
                })
              "
            >
              {{ dossier.name }} : {{ dossier.quantity }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-8">
      <div class="col-span-2 col-start-7 mb-2 mr-10 rounded-lg bg-gray-200 p-2">
        <div class="space-2 w-full font-medium">
          <div class="capitalize-first">
            {{ $t('global.ref_number') }}:
            {{ supplierOrder.supplierOrderItems?.length }}
          </div>
          <div v-if="supplierOrder.status === 'REC'" class="capitalize-first">
            {{ $t('global.total_htva') }} : {{ total }} €
          </div>
          <div v-else class="capitalize-first">
            {{ $t('global.estimate_total_htva') }} : {{ total }} €
          </div>
        </div>
      </div>
      <div
        v-if="supplierOrder.status === 'DRA'"
        class="col-start-8 mb-3 ml-6 flex justify-between"
      >
        <BaseButton
          :title="$t('button.save')"
          icon="paper-plane"
          color="primary"
          size="extra-small"
          @click="$emit('update-supplier-order', supplierOrder)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BaseShowEditInput from '@c/addf-package/components/BaseShowEditInput/BaseShowEditInput.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'SupplierOrderTableCardComponent',
  components: { FontAwesomeIcon, BaseButton, BaseShowEditInput },
  props: {
    supplierOrder: {
      type: Object,
      required: true
    },
    editionMode: {
      type: Boolean,
      required: true
    }
  },
  emits: ['delete-item', 'update-supplier-order'],
  data() {
    return {
      receive_item_ids: [],
      in_order_items: []
    }
  },
  computed: {
    ...mapGetters({
      initialMetadata: 'metadata/getInitialMetadata'
    }),
    total() {
      if (!this.supplierOrder?.supplierOrderItems) {
        return '0.00'
      }
      const total = this.supplierOrder.supplierOrderItems.reduce(
        (sum, item) => {
          const price = isNaN(parseFloat(item.price_htva))
            ? 0
            : parseFloat(item.price_htva)
          const quantity_added = isNaN(parseInt(item.quantity_added))
            ? 0
            : parseInt(item.quantity_added)
          const itemTotal = price * quantity_added
          const dossierTotal =
            item.dossiers?.reduce((dossierSum, dossier) => {
              return dossierSum + price * parseInt(dossier.quantity)
            }, 0) ?? 0

          return sum + itemTotal + dossierTotal
        },
        0
      )

      return total.toFixed(2)
    }
  },
  mounted() {
    this.receive_item_ids = this.supplierOrder.receive_items?.map(
      (item) => item.id
    )
  },
  methods: {
    addInOrderItems(dossier, supplier_order_item) {
      if (supplier_order_item.add_order.includes(dossier.id)) {
        supplier_order_item.add_order = supplier_order_item.add_order.filter(
          (element) => element !== dossier.id
        )
      } else {
        supplier_order_item.add_order.push(dossier.id)
      }
    },
    refreshTotalQuantity(supplier_order_item) {
      supplier_order_item.quantity = supplier_order_item.dossiers?.reduce(
        (total, dossier) => {
          return total + dossier.quantity
        },
        Number(supplier_order_item.quantity_added)
      )
    },
    deleteItem(index) {
      this.$emit('delete-item', index)
    }
  }
}
</script>
